import { render, staticRenderFns } from "./ExcelPaste.vue?vue&type=template&id=2d4f2dfa"
import script from "./ExcelPaste.vue?vue&type=script&lang=js"
export * from "./ExcelPaste.vue?vue&type=script&lang=js"
import style0 from "./ExcelPaste.vue?vue&type=style&index=0&id=2d4f2dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports